import {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {genericErrorHasOccurred} from '../actions/generic-error/action-creators';
import {PAYMENT_STATUS_RECHECK_FREQUENCY} from '../consts';
import {isTransactionDone as genericIsTransactionDone} from '../utils/isTransactionDone';

export const useGenericStatusPage = ({
    paymentSessionId,
    languageCode,
    dispatch,
    initData,
    initError,
    recheckFrequency = PAYMENT_STATUS_RECHECK_FREQUENCY,
    getPaymentStatus,
    isTransactionDone = genericIsTransactionDone
}) => {
    const history = useHistory();

    const [data, setData] = useState(initData);
    const [error, setError] = useState(initError);

    const getStatus = () => getPaymentStatus({
        languageCode,
        paymentSessionId
    })
        .then(newData => {
            setData(newData);
            if (!isTransactionDone(newData)) {
                setTimeout(getStatus, recheckFrequency);
            }
        })
        .catch(err => {
            setError(err);
            setTimeout(getStatus, recheckFrequency);
        });

    useEffect(() => {
        history.replace({
            pathname: window.location.pathname,
            search: ''
        });

        if (error || !isTransactionDone(data)) {
            getStatus();
        }
    }, []);

    useEffect(() => {
        if (error) {
            dispatch(genericErrorHasOccurred(true));
        }
    }, [error, dispatch]);

    useEffect(() => {
        if (isTransactionDone(data)) {
            window.location.assign(data.redirectUrl);
        }
    }, [data]);


    return {
        data,
        error
    };
};
